// Import Global Contexts
import { CURRENCY, useCalculatorContext } from '../contexts/CalculatorContext';
// Import Functions
import formatToMoney from "./../functions/formatToMoney";
import { toggleHistory } from "./Functions";
//Import Assets
import { faChevronRight, faRedo, faShareAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const History = () => {

    // Use the Global Calculator Context 
     const {
        setModalForm, setFob,
        setFlete, setTax,
        setSubtotal, setExtraExpenses,
        setExtraExpensesCheck, setOperationalExpenses,
        setOperationalExpensesCheck, setTotalInsured,
        setRate, setMinPremium, setPremium, 
        history, setHistory, setCurrentPremim,
        activePremium, setCurrency
    } = useCalculatorContext();
    
     /***********************************************************
     *  Funciones *
    * **********************************************************/
   
    const removePremium = (id) => {
        // Use filter to exclude the no desired premium
        setHistory(
                history.filter((item) => { 
                if (item.id != id) {
                    return item;
                }
            })
        );

        // Check if the premium to remove is the current active premium
        if(activePremium == id){
            // Clear all the form fields
            setFob('');
            setFlete('');
            setTax('');
            setSubtotal('0');
            setExtraExpenses('0');
            setExtraExpensesCheck(false);
            setOperationalExpenses('0');
            setOperationalExpensesCheck(false);
            setTotalInsured('0');
            setRate('');
            setMinPremium('');
            setPremium(0);
            setCurrency(CURRENCY.USD);
        }
    }

    const sharePremium = (id) => {
        // Update the active premium
        setModalForm({
            visible: true,
            premiumId: id
        });
    }
  
    /* Devolvemos los inputs */
    return ( 
        <>
            <div className="historyContainer">
                <h2 className="title">History</h2>
                <ul className="history-list">
                    {
                        (history.length === 0) ? <li key={"no-history"}>{"There's no history yet"}</li>
                        :
                        [...history].reverse().map((el) => (
                            <li className="item-list" key={el.id}>
                                <span>
                                {el.id === activePremium ? 'Selected - ' : ''}Premium #{el.id}
                                </span>
                                <div className="row">
                                <div className="btns-wrap">
                                    <button className="btn-icon" onClick={()=>setCurrentPremim(el.id)}><FontAwesomeIcon icon={faRedo} /></button>
                                    <button className="btn-icon" onClick={()=>sharePremium(el.id)}><FontAwesomeIcon icon={faShareAlt} /></button>
                                    <button className="btn-icon" onClick={()=>removePremium(el.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                </div>
                                {formatToMoney(el.premium, el.currency)}
                                </div>
                            </li>
                        ))
                    } 
                </ul>
                
            </div>
            <button className="toggleHistory" onClick={(e)=>{toggleHistory()}}>
                <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </>
       
     );
}
 

export default History;